import { Button, ButtonProps } from 'antd'
import React, { useState } from 'react'

type Props = ButtonProps

export const ButtonLoadingOnClick: React.FC<Props> = ({
  loading,
  children,
  onClick,
  ...props
}) => {
  const [isLoading, setLoading] = useState(false)

  const handleClick = async event => {
    setLoading(true)
    await onClick(event)
    setLoading(false)
  }

  return (
    <Button
      {...props}
      onClick={onClick ? handleClick : undefined}
      loading={isLoading}
    >
      {children}
    </Button>
  )
}
